$(document).ready(function () {
	// CATEGORIES - MOBILE
	$('.JScategories .bi-list').on('click', function () { 
		$('.JSlevel-1').slideToggle();
	});

	$('.JSsubcat-toggle').on('click', function() {
		var $toggle = $(this);
		var $siblingItems = $toggle.parent().siblings();

		$toggle.toggleClass('rotate');
		$toggle.siblings('ul').slideToggle();
		$siblingItems.children('ul').slideUp();
		$siblingItems.find('.JSsubcat-toggle').removeClass('rotate');
	});

	/*======= MAIN CONTENT HEIGHT ========*/
	var DESKTOP_BREAKPOINT = 1024;

	$('.JScategories').on('mouseenter', function () {
		if ($(window).width() <= DESKTOP_BREAKPOINT) return;

		if ($('.d-content').height() < $('.JSlevel-1').height()) { 
			$('.d-content').height($('.JSlevel-1').height());
		}
	}).on('mouseleave', function () {
		if ($(window).width() <= DESKTOP_BREAKPOINT) return;

		$('.d-content').height('');
	});
});